import { render, staticRenderFns } from "./UploadList.vue?vue&type=template&id=38677e15"
import script from "./UploadList.vue?vue&type=script&lang=js"
export * from "./UploadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports